import { HelperResult, UserAllowances, Allowances } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserAllowances, useUpdate: useUpdateUserAllowances } = getCRUDHooks({
  entityName: 'userAllowances',
  get: ({ userId }): HelperResult<UserAllowances[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).allowances.find(),
  update: (values, { userId, context }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .allowances.update('', values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
});

const { useGet: useAllowances } = getCRUDHooks({
  entityName: 'allowances',
  get: ({ userCountry }): HelperResult<Allowances[]> =>
    clientApi.getOCClient().helpers.allowances.allowances.find({ countries: userCountry }),
});

export { useUserAllowances, useUpdateUserAllowances, useAllowances };
